import { render, staticRenderFns } from "./cancel-tab.vue?vue&type=template&id=e1ca5a34"
import script from "./cancel-tab.vue?vue&type=script&lang=js"
export * from "./cancel-tab.vue?vue&type=script&lang=js"
import style0 from "./cancel-tab.vue?vue&type=style&index=0&id=e1ca5a34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports